import type { TargetedKeyboardEvent } from 'preact';

import type { TemplateFunction, TemplateResult } from 'Components/types';
import { autocompleteTotalHitsSelector } from 'Core/selectors/autocomplete';
import { useSelector } from 'Core/store';
import { cloneSafe } from 'Utils/components';

interface Props {
  template: TemplateFunction<BrowseAllButtonTemplateParams>;
  submit: (query: string) => void;
  query: string;
  vehicleString?: string;
}

export interface BrowseAllButtonTemplateParams {
  totalHits: number;
  query: string;
  vehicleString?: string;
}

export default function BrowseAllButton({ template, submit, query, vehicleString }: Props): TemplateResult {
  const totalHits = useSelector(autocompleteTotalHitsSelector);

  if (!totalHits) {
    return null;
  }

  const onKeyDown = (e: TargetedKeyboardEvent<HTMLElement>) => e.key === 'Enter' && submit(query);

  const component = template.call({ totalHits, query, vehicleString });
  return cloneSafe(component, null, {
    onClick: () => submit(query),
    onKeyDown,
    tabIndex: -1,
    appendedClasses: 'nav-item',
  });
}
